import { render, staticRenderFns } from "./PageRange.vue?vue&type=template&id=65ede23a&"
import script from "./PageRange.vue?vue&type=script&lang=js&"
export * from "./PageRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports